<script setup lang="ts">
defineProps<{ params: { data: { status: string } } }>()

const statusConfig: Record<string, { label: string; class: string }> = {
  PENDING: { label: 'En attente', class: 'bg-blue-100' },
  COMPLETED: { label: 'Signé', class: 'bg-emerald-100' },
  DECLINED: { label: 'Refusé', class: 'bg-red-100' },
  EXPIRED: { label: 'Expiré', class: 'bg-orange-100' },
  ARCHIVED: { label: 'Archivé', class: 'bg-gray-200' },
}

function getLabel(status: string) {
  return statusConfig[status]?.label || status
}
function getClass(status: string) {
  return statusConfig[status]?.class || 'badge-ghost'
}
</script>

<template>
  <div class="flex items-center w-full">
    <span class="badge" :class="getClass(params.data.status)">
      {{ getLabel(params.data.status) }}
    </span>
  </div>
</template>
